module.exports = mycorvinus_navigator;